<!--
 * @Author: your name
 * @Date: 2019-11-08 16:35:18
 * @LastEditTime: 2019-11-15 18:32:11
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \source\src\components\onlineMap\collectFolder\UCCollectFolderList.vue
 -->
<!--  -->
<template>
  <div class="divUCCollectFolderList">

    <ul class="ul_folders">
      <li
        class="liItem"
        v-for="item in folders.objects"
        :key="item.id"
        @mouseover="_folderItemMouseOverHandler(item)"
        @mouseout="_folderItemMouseOutHandler(item)"
        
      >

        <i class="com-icon"></i>

        <div class="folder_info" @click="_folderItemClickHandler(item)">
          <p class="folder_info_name"> {{item.name}}</p>
          <p class="folder_info_createTime">{{item.createTime}}</p>
        </div>

        <a
          v-show="componentSetting.folderEditVisible"
          class="folder_edit"
          title="编辑"
          @click="_itemEditClickHandler(item)"
        ></a>
        <a
          v-show="componentSetting.folderDeleteVisible"
          class="folder_delete"
          title="删除"
          @click="_itemDeleteClickHandler(item)"
        ></a>

      </li>

    </ul>

    <UCFormCollectFolder ref="ucFormCollFolder"></UCFormCollectFolder>

  </div>
</template>

<script>
import UCFormCollectFolder from "./UCFormCollectFolder.vue";
import {
  UserCollectFolder,
  UserCollectFolders,
  UserCollectFolderFilter,
  UserCollectFolderFilterResult
} from "../model/UserCollectJs.js";
import { ServiceUrlConfig } from "../../../config/ServiceUrlConfigJs";
import { UCCollectFolderEvents } from "./UCCollectFolderJs.js";
import { UCOperationType } from "../UCComponentJs.js";
import { TdtUser } from '../model/TdtUserJs';

export default {
  name: "UCCollectFolderList",
  data() {
    return {
      componentSetting: {
        folderEditVisible: false,

        folderDeleteVisible: false
      },

      folders: new UserCollectFolders(),

      currentFolder: null
    };
  },

  components: { UCFormCollectFolder },

  computed: {},

  mounted() {},

  methods: {
    init() {
      this.folders = new UserCollectFolders();
      this.currentFolder = null;

      this._initDataProvider();

      this._initEvents();
    },

    /**
     * 添加文件夹
     */
    addFolder(folder) {
      if (!this.folders) {
        this.folders = new UserCollectFolders();
      }

      this.folders.push(folder);
    },

    updateFolder(folder) {
      if (!this.folders || !folder) return;

      let findItem = this.folders.findById(folder.id);
      if (findItem != -1) {
        findItem.name=folder.name;
      }
    },

    off_folderItemClick(callback) {
      if (callback) {
        this.$off(
          UCCollectFolderEvents.UCCollectFolderList_event_itemClick,
          callback
        );
      }
    },

    on_folderItemClick(callback) {
      if (callback) {
        this.$on(
          UCCollectFolderEvents.UCCollectFolderList_event_itemClick,
          callback
        );
      }
      
    },

    _initEvents() {
      this.$refs.ucFormCollFolder.off_updateSucceed(this._folderUpdateHandler);
      this.$refs.ucFormCollFolder.on_updateSucceed(this._folderUpdateHandler);
    },

    _initDataProvider() {
      let self = this;

      let curUser = TdtUser.currentUser;

      if(!curUser)return;
      

      let filter = new UserCollectFolderFilter();
      filter.useUserId=true;
      filter.userId=curUser.name;

      let selectUrl = ServiceUrlConfig.platform_collectfolder_selectByFilter;

      UserCollectFolders.selectByFilter(
        filter,
        selectUrl,
        function(response) {
          if (response) {
            let filterResult = UserCollectFolderFilterResult.fromJson(response);
            if (filterResult && filterResult.filterFolders) {
              self.folders = filterResult.filterFolders;
            }
          }
        },
        function(erorr) {}
      );
    },

    _folderItemMouseOverHandler() {
      this.componentSetting.folderEditVisible = true;
      this.componentSetting.folderDeleteVisible = true;
    },

    _folderItemMouseOutHandler() {
      this.componentSetting.folderEditVisible = false;
      this.componentSetting.folderDeleteVisible = false;
    },

    _folderItemClickHandler(folderItem) {
      this.$emit(
        UCCollectFolderEvents.UCCollectFolderList_event_itemClick,
        folderItem
      );
    },

    _itemEditClickHandler(item) {
      if (!item) return;

      let itemCopy = item.copyBasicInfo();

      this.$refs.ucFormCollFolder.init(
        UCOperationType.operation_update,
        itemCopy
      );

      this.$refs.ucFormCollFolder.showForm();
    },

    _itemDeleteClickHandler(item) {
      if (!item) return;

      let self = this;

      this.$confirm("是否确认删除文件夹" + item.name + "?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(function() {
          let curId = item.id;
          let ids = new Array();
          ids.push(curId);

          let deleteMultiUrl =
            ServiceUrlConfig.platform_collectfolder_deleteMulti;

          UserCollectFolders.deleteMulti(
            ids,
            deleteMultiUrl,
            function(response) {
              if (response.code == "ok") {
                self.$message({
                  showClose: true,
                  type: "success",
                  message: "删除成功!"
                });

                let findIndex = self.folders.findIndexById(curId);
                if (findIndex !== -1) {
                  self.folders.objects.splice(findIndex, 1);
                }
              } else {
                self.$message({
                  showClose: true,
                  type: "info",
                  message: "删除失败!"
                });
              }
            },
            function() {
              self.$message({
                showClose: true,
                type: "error",
                message: "删除失败!"
              });
            }
          );
        })
        .catch(function() {
          self.$message({
            showClose: true,
            type: "info",
            message: "已取消删除"
          });
        });
    },

    _itemPickMouseOverHandler() {},

    _itemPickMouseOutHandler() {},

    _folderUpdateHandler(folder) {
      if (!folder) return;

      this.updateFolder(folder);
    }
  }
};
</script>


<style lang="scss" scoped>
.com-icon {
  background: url("../../../assets/onlineMap/icon.png");
  background-repeat: no-repeat;

  background-position: -496px -183px;
  width: 24px;
  height: 20px;

  display: inline-block;
}

.folder_info {
  margin-left: 12px;
  position: relative;
  margin-right: 50px;

  .folder_info_name{
    color: #4c4c4c;
    font-weight: 700;
  }

  .folder_info_createTime
  {
    color: gray;
  }

  p {
    font-size: 12px;
    margin: 0px;
    height: 16px;
  }


}

.divUCCollectFolderList {
  width: 100%;
  height: 100%;
  

  .ul_folders {
    padding: 10px 20px;
    height: 100%;
    
    li:hover {
      cursor: pointer;
    }

    .liItem {
      display: flex;
      height: 50px;
      align-items: center;
      flex-direction: row;
      justify-content: flex-start;

      .spanItem {
        color: #2f87eb;
        cursor: pointer;
      }

      a {
        margin-left: 10px;

      }

      .folder_edit {
        background: url("../../../assets/onlineMap/icon.png");
        background-position: -588px -189px;
        width: 14px;
        height: 14px;
        display: inline-block;

        background-repeat: no-repeat;
      }

      .folder_delete {
        background: url("../../../assets/onlineMap/icon.png");
        background-position: -138px 0;
        width: 15px;
        height: 16px;
        display: inline-block;

        background-repeat: no-repeat;
      }
    }
  }
}
</style>
